import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
  useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
  , useStylesUiElemment,
  useStylesSpDial,
  useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import { useTranslation } from "react-i18next";


export default function CustomersSearchForm(props) {

  const {
    optionsUsers,
    rptParams,
    onChangeData,
    onChangeAutoData,
    type,
    TYPEACIVE
  } = props;
  const { t } = useTranslation(["forms", "translation"]);
  const calsBlack = useStylesAutoBlack();

  const clasup = useStylesUp();
  const calsPurch = useStylesAutoPurch();
  const claslbl = useStylesLbl();
  const clasAo = useStylesAuto();
  const clasTF = useStylesTF();

  return (
    <React.Fragment>

      <Grid container style={{ padding: 5 }} spacing={1}>
        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
          <TextField fullWidth variant="outlined" size="small" id="dateT"
            label={rptParams.type.id == 2 ? t("supplier-name") : t("customer-name")}
            type="text"
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlack }}
            InputLabelProps={{ className: claslbl.clrBlack }}
            name="name" value={rptParams.name}
            onChange={onChangeData("name")} />
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
          <TextField fullWidth variant="outlined" size="small" id="dateT"
            label={t("mobile-number")}
            type="text"
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlack }}
            InputLabelProps={{ className: claslbl.clrBlack }}
            name="mobile" value={rptParams.mobile}
            onChange={onChangeData("mobile")} />
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
          <TextField fullWidth variant="outlined" size="small" id="dateT"
            label={t("account-no")}
            type="number"
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlack }}
            InputLabelProps={{ className: claslbl.clrBlack }}
            name="acc_no" value={rptParams.acc_no}
            onChange={onChangeData("acc_no")} />
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
          <TextField fullWidth variant="outlined" size="small" id="dateT"
            label={t("address")}
            type="text"
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlack }}
            InputLabelProps={{ className: claslbl.clrBlack }}
            name="address" value={rptParams.address}
            onChange={onChangeData("address")} />
        </Grid>
        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
          <TextField fullWidth variant="outlined" size="small" id="dateT"
            label={t("tax-number")}
            type="text"
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlack }}
            InputLabelProps={{ className: claslbl.clrBlack }}
            name="vat_num" value={rptParams.vat_num}
            onChange={onChangeData("vat_num")} />
        </Grid>
        <Grid item lg={2} md={2} sm={3} xs={6}>
          <Autocomplete
            value={rptParams.users}
            classes={calsBlack}
            onChange={(event, newValue) => {
              onChangeAutoData("users", newValue)
            }}
            id="combo-box-demo" size="small"
            options={optionsUsers ?? 0}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
            style={{}}
            disableClearable
            renderInput={(params) => <TextField {...params}
              label={t("salesman")} variant="outlined" size='small'
              InputLabelProps={{ shrink: true, className: claslbl.clrBlack }} />}
          />
        </Grid>
        {type == 1 &&
          <Grid item lg={2} md={2} sm={3} xs={6}>
            <Autocomplete
              value={rptParams.type_active}
              classes={calsBlack}
              onChange={(event, newValue) => {
                onChangeAutoData("type_active", newValue)
              }}
              id="combo-box-demo" size="small"
              options={TYPEACIVE ?? 0}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
              style={{}}
              disableClearable
              renderInput={(params) => <TextField {...params}
                label={t("type")} variant="outlined" size='small'
                InputLabelProps={{ shrink: true, className: claslbl.clrBlack }} />}
            />
          </Grid>
        }
      </Grid>

    </React.Fragment>
  );

}